import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      OTHER_WAYS_WE_CAN_HELP_YOU: "Andre måter vi kan hjelpe deg på",
      THESE_TWO_POSSIBILITIES_MAKES_IT_EASIER_FOR_YOU:
        "Disse to alternativene gjør det lettere for deg å få hverdagen til å henge sammen.",

      PAUSE_FOR_PERIOD: "Pause i en begrenset periode",
      GOING_ON_VACATION: "Skal du på ferie?",
      PAUSE_SUBSCRIPTION: "Pause begrenset periode",

      CHANGE_INTERVAL: "Endre leveringsintervaller",
      RECEIVING_DELIVERIES_TOO_OFTEN: "Får du leveranser for ofte?",
      CHANGE_DELIVERY_INTERVAL: "Endre leveringsintervaller",

      DO_YOU_STILL_WANT_TO_CANCEL_YOUR_SUBSCRIPTION:
        "Vil du fortsatt pause abonnementet ditt?",
      CANCEL_SUBSCRIPTION: "Pause abonnement",
      KEEP_YOUR_DISCOUNTS: "Og behold dine rabatter!",
    },

    dk: {
      OTHER_WAYS_WE_CAN_HELP_YOU: "Andre måder vi kan hjælpe dig på",
      THESE_TWO_POSSIBILITIES_MAKES_IT_EASIER_FOR_YOU:
        "Disse to muligheder gør det nemmere for dig at få din hverdag til at hænge sammen.",

      PAUSE_FOR_PERIOD: "Hold pause i begrænset periode",
      GOING_ON_VACATION: "Skal du ud at rejse?",
      PAUSE_SUBSCRIPTION: "Pause i begrænset periode",

      CHANGE_INTERVAL: "Skift dit leveringsinterval",
      RECEIVING_DELIVERIES_TOO_OFTEN: "Modtager du leveringer for ofte?",
      CHANGE_DELIVERY_INTERVAL: "Skift leveringsinterval",

      DO_YOU_STILL_WANT_TO_CANCEL_YOUR_SUBSCRIPTION:
        "Vil du stadig opsige abonnement?",
      CANCEL_SUBSCRIPTION: "Opsig",
      KEEP_YOUR_DISCOUNTS: "Og behold dine rabatter!",
    },

    se: {
      OTHER_WAYS_WE_CAN_HELP_YOU: "Andra sätt vi kan hjälpa dig",
      THESE_TWO_POSSIBILITIES_MAKES_IT_EASIER_FOR_YOU:
        "Dessa två alternativ gör det lättare för dig att få din vardag att hänga ihop.",

      PAUSE_FOR_PERIOD: "Pausa en begränsad tid",
      GOING_ON_VACATION: "Ska du på semester?",
      PAUSE_SUBSCRIPTION: "Pausa en begränsad period",

      CHANGE_INTERVAL: "Ändra leveransintervall",
      RECEIVING_DELIVERIES_TOO_OFTEN: "Får du leveranser för ofta?",
      CHANGE_DELIVERY_INTERVAL: "Ändra leveransintervall",

      DO_YOU_STILL_WANT_TO_CANCEL_YOUR_SUBSCRIPTION:
        "Vill du fortfarande avsluta din prenumeration?",
      CANCEL_SUBSCRIPTION: "Avsluta prenumeration",
      KEEP_YOUR_DISCOUNTS: "Och behåll dina rabatter!",
    },
  } as const
)[language];
